// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"12":"f3e5f6e3","136":"d680e643","230":"42332b39","443":"01f70081","697":"b89bd1f7"}[chunkId] + ".css";
};